<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { presentSalesHistoryEvent } from '../composables/salesHistoryPresentation';
import SalesHistoryItem from './SalesHistoryItem.vue';

const props = defineProps({ events: { type: Array, default: () => [] } });
const { t } = useI18n();

const entries = computed(() => props.events.map(presentSalesHistoryEvent));
</script>

<template>
  <section
    data-test="sales-history-timeline"
    class="rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <h3 class="font-redHatDisplay text-lg font-semibold text-lais-text">
      {{ t('SALES.HISTORY.TITLE') }}
    </h3>
    <ol
      v-if="entries.length"
      data-test="sales-history-list"
      class="mt-3 list-none"
    >
      <SalesHistoryItem
        v-for="entry in entries"
        :key="entry.key"
        :entry="entry"
      />
    </ol>
    <p v-else class="mt-3 text-sm text-lais-text-muted">
      {{ t('SALES.DETAIL.NO_HISTORY') }}
    </p>
  </section>
</template>
